import React, { useState, useEffect } from 'react'
import { useGetMyInfo } from 'app/gomsacademy/hooks/GetMyInfo'
import { useAcademyList } from 'app/gomsacademy/hooks/AcademyList'
import { usePaySSAMMerchant } from 'app/gomsacademy/hooks/PaySSAMMerchant'
import { LectureWrapper, LectureView, LectureViewHeader } from '../Lecture/styles'
import API from 'utils/api'
import { useToken } from 'app/hooks'
import { message, Card, Descriptions, Button, Input, Upload } from 'antd'
import { STORAGE_URL } from 'app/constants/APIKEYS'
import styled from 'styled-components'
import * as antd from 'antd'

const MyAcademy = () => {
	const { data: token } = useToken()
	const { myInfo } = useGetMyInfo()
	const { AcademyListData, mutate: academyMutate } = useAcademyList()

	const currentBranch = AcademyListData?.find((b: any) => b.name === myInfo?.branchName)
	const deptId = currentBranch?.id

	const [isFix, setIsFix] = useState(false)
	const [fixName, setFixName] = useState(currentBranch?.name || '')
	const [fixDirector, setFixDirector] = useState(currentBranch?.representativeName || '')
	const [fixTel, setFixTel] = useState(currentBranch?.tel || '')
	const [fixAddress, setFixAddress] = useState(currentBranch?.address || '')
	const [uploading, setUploading] = useState(false)

	const {
		merchantStatus,
		merchantInfo,
		loadingStatus: loadingMerchantStatus,
		loadingInfo: loadingMerchantInfo,
		registering: registeringMerchant,
		registerMerchant,
		refreshStatus,
		getMerchantInfo,
	} = usePaySSAMMerchant(deptId)
	const rawBranchMerchantStatus = currentBranch
		? {
				memberId: (currentBranch as any).payssamMemberId,
				merchantId: (currentBranch as any).payssamMerchantId,
				reviewStatus: (currentBranch as any).payssamReviewStatus,
				openCode: (currentBranch as any).payssamOpenCode,
				lastSyncedAt: (currentBranch as any).payssamLastSyncedAt,
			}
		: null
	const branchMerchantStatus = rawBranchMerchantStatus?.memberId || rawBranchMerchantStatus?.merchantId || rawBranchMerchantStatus?.reviewStatus || rawBranchMerchantStatus?.openCode
		? rawBranchMerchantStatus
		: null
	const effectiveMerchantStatus = merchantStatus || branchMerchantStatus ? { ...(branchMerchantStatus || {}), ...(merchantStatus || {}) } : null
	const isSubMerchantStatusUnknown = Boolean(
		effectiveMerchantStatus?.subMerchantSyncErrorCode || effectiveMerchantStatus?.subMerchantSyncErrorMessage,
	)
	const isPaymentEnabled = Boolean(
		effectiveMerchantStatus?.paymentAvailable,
	)
	const hasMerchantConnection = Boolean(
		effectiveMerchantStatus?.isLinked || effectiveMerchantStatus?.memberId || effectiveMerchantStatus?.merchantId,
	)
	const getMerchantStatusText = () => {
		if (!effectiveMerchantStatus) return '연동 정보 없음'
		if (isPaymentEnabled) return '연동됨 (결제 가능)'
		if (effectiveMerchantStatus.openCode === '1010') return '미신청/심사중'
		if (effectiveMerchantStatus.openCode === '1700') return '기가입 매장 확인 필요'
		if (!hasMerchantConnection && isSubMerchantStatusUnknown) return '연동 상태 확인 필요'
		if (!hasMerchantConnection) return '미연동'
		if (effectiveMerchantStatus.reviewStatus === 'W') return '작성중'
		if (effectiveMerchantStatus.reviewStatus === 'P') return '심사중'
		if (effectiveMerchantStatus.reviewStatus === 'R') return '반려'
		if (effectiveMerchantStatus.reviewStatus === 'S') return '보완 필요'
		if (effectiveMerchantStatus.isLinked || effectiveMerchantStatus.memberId || effectiveMerchantStatus.merchantId) return '연동 정보 있음 (결제 대기)'
		return '연동 상태 확인 필요'
	}

	useEffect(() => {
		if (currentBranch) {
			setFixName(currentBranch.name || '')
			setFixDirector(currentBranch.representativeName || '')
			setFixTel(currentBranch.tel || '')
			setFixAddress(currentBranch.address || '')
		}
	}, [currentBranch])

	useEffect(() => {
		if (deptId) {
			refreshStatus(false)
		}
	}, [deptId, refreshStatus])

	useEffect(() => {
		if (isPaymentEnabled && !merchantInfo) {
			getMerchantInfo().catch(() => {
				// error already handled in hook
			})
		}
	}, [isPaymentEnabled, merchantInfo, getMerchantInfo])

	const SaveAcademy = () => {
		if (!deptId) return
		API.put('/branch/' + deptId, token + '', {
			datas: {
				name: fixName,
				representativeName: fixDirector,
				tel: fixTel,
				address: fixAddress,
			},
		})
			.then((res: any) => {
				if (res.result?.success) {
					message.success('수정되었습니다')
					academyMutate()
					setIsFix(false)
				} else {
					message.error(res.result?.message || '수정에 실패했습니다.')
				}
			})
			.catch(() => message.error('수정 중 오류가 발생했습니다.'))
	}

	const handleLogoUpload = async (file: File) => {
		if (!deptId) return false
		const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
		if (!isJpgOrPng) {
			message.error('JPG/PNG 파일만 업로드 가능합니다.')
			return false
		}
		if (file.size / 1024 / 1024 >= 10) {
			message.error('이미지는 10MB 이하여야 합니다.')
			return false
		}
		const formData = new FormData()
		formData.append('file', file)
		setUploading(true)
		try {
			const res = await API.postImage('POST', `/branch/${deptId}/logo`, token + '', formData)
			if (res.result?.success) {
				message.success('로고가 변경되었습니다.')
				academyMutate()
			} else {
				message.error(res.result?.message || '업로드에 실패했습니다.')
			}
		} catch {
			message.error('업로드 중 오류가 발생했습니다.')
		} finally {
			setUploading(false)
		}
		return false
	}

	if (!deptId) {
		return (
			<Wrapper>
				<LectureView>
					<EmptyState>지점 정보를 찾을 수 없습니다.</EmptyState>
				</LectureView>
			</Wrapper>
		)
	}

	return (
		<Wrapper>
			<LectureView>
				<LectureViewHeader>
					<p>내 학원 관리</p>
				</LectureViewHeader>

				<Card title="학원 정보" style={{ marginBottom: 24 }}>
					{!isFix ? (
						<Descriptions bordered column={1}>
							<Descriptions.Item label="학원명">{currentBranch?.name || '-'}</Descriptions.Item>
							<Descriptions.Item label="대표자">{currentBranch?.representativeName || '-'}</Descriptions.Item>
							<Descriptions.Item label="연락처">{currentBranch?.tel || '-'}</Descriptions.Item>
							<Descriptions.Item label="주소">{currentBranch?.address || '-'}</Descriptions.Item>
						</Descriptions>
					) : (
						<>
							<FormRow>
								<FormLabel>학원명</FormLabel>
								<Input value={fixName} onChange={e => setFixName(e.target.value)} placeholder="학원명" />
							</FormRow>
							<FormRow>
								<FormLabel>대표자</FormLabel>
								<Input value={fixDirector} onChange={e => setFixDirector(e.target.value)} placeholder="대표자명" />
							</FormRow>
							<FormRow>
								<FormLabel>연락처</FormLabel>
								<Input value={fixTel} onChange={e => setFixTel(e.target.value)} placeholder="연락처" />
							</FormRow>
							<FormRow>
								<FormLabel>주소</FormLabel>
								<Input value={fixAddress} onChange={e => setFixAddress(e.target.value)} placeholder="주소" />
							</FormRow>
						</>
					)}
					<ButtonRow>
						{!isFix ? (
							<antd.Button type="primary" onClick={() => setIsFix(true)}>
								정보 수정
							</antd.Button>
						) : (
							<>
								<antd.Button type="primary" onClick={SaveAcademy}>
									저장
								</antd.Button>
								<antd.Button onClick={() => setIsFix(false)}>취소</antd.Button>
							</>
						)}
					</ButtonRow>
				</Card>

				<Card title="로고 변경" style={{ marginBottom: 24 }}>
					{currentBranch?.logoUrl && (
						<div style={{ marginBottom: 16 }}>
							<img src={`${STORAGE_URL}/${currentBranch.logoUrl}`} alt="로고" style={{ maxHeight: 80 }} />
						</div>
					)}
					<Upload accept=".jpg,.jpeg,.png" showUploadList={false} beforeUpload={handleLogoUpload} disabled={uploading}>
						<antd.Button loading={uploading}>로고 업로드 (JPG/PNG, 10MB 이하)</antd.Button>
					</Upload>
				</Card>

				<Card title="가맹점 신청 현황" style={{ marginBottom: 24 }}>
					<Descriptions bordered column={1}>
						<Descriptions.Item label="결제선생 연동 상태">
							{effectiveMerchantStatus ? (
								<>
									<span style={{ marginRight: 8 }}>{getMerchantStatusText()}</span>
									{effectiveMerchantStatus.reviewStatus && (
										<antd.Tag>
											{effectiveMerchantStatus.reviewStatus === 'W'
												? '작성중'
												: effectiveMerchantStatus.reviewStatus === 'P'
												? '심사요청'
												: effectiveMerchantStatus.reviewStatus === 'R'
												? '반려'
												: effectiveMerchantStatus.reviewStatus === 'S'
												? '보완'
												: effectiveMerchantStatus.reviewStatus === 'O'
												? '개시됨'
												: effectiveMerchantStatus.reviewStatus === 'N'
												? '심사없음'
												: effectiveMerchantStatus.reviewStatus}
										</antd.Tag>
									)}
									{isSubMerchantStatusUnknown && !hasMerchantConnection && <antd.Tag color="warning">조회 필요</antd.Tag>}
								</>
							) : (
								<span>연동 정보 없음</span>
							)}
						</Descriptions.Item>
						{(currentBranch as any)?.requested_at && (
							<Descriptions.Item label="가입 요청일">
								{new Date((currentBranch as any).requested_at).toLocaleDateString('ko-KR')}
							</Descriptions.Item>
						)}
					</Descriptions>
					<div style={{ marginTop: 16, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
						{!hasMerchantConnection && !isSubMerchantStatusUnknown ? (
							<antd.Button type="primary" onClick={registerMerchant} loading={registeringMerchant}>
								연동 시작
							</antd.Button>
						) : (
							<>
								<antd.Button onClick={() => refreshStatus()} loading={loadingMerchantStatus}>
									상태 새로고침
								</antd.Button>
								<antd.Button onClick={() => getMerchantInfo()} loading={loadingMerchantInfo}>
									가맹점 정보 보기
								</antd.Button>
							</>
						)}
					</div>
					{merchantInfo && (
						<div style={{ marginTop: 16 }}>
							<Descriptions bordered column={1} size="small">
								{/* <Descriptions.Item label="상호">{merchantInfo.info?.company || '-'}</Descriptions.Item> */}
								{/* <Descriptions.Item label="지점명">{merchantInfo.info?.branch || '-'}</Descriptions.Item> */}
								{/* <Descriptions.Item label="사업자번호">{merchantInfo.info?.corp_num || '-'}</Descriptions.Item> */}
								{/* <Descriptions.Item label="대표자">{merchantInfo.info?.ceo || '-'}</Descriptions.Item> */}
								{/* <Descriptions.Item label="이메일">{merchantInfo.info?.email || '-'}</Descriptions.Item> */}
								<Descriptions.Item label="Member ID">{merchantInfo.info?.member || '-'}</Descriptions.Item>
								<Descriptions.Item label="Merchant ID">{merchantInfo.info?.merchant || '-'}</Descriptions.Item>
							</Descriptions>
						</div>
					)}
					<p style={{ marginTop: 12, color: '#666', fontSize: 13 }}>
						결제선생 가맹점 등록/심사는 메뉴의 &quot;가맹점 관리&quot; 또는 이 페이지에서 진행할 수 있습니다.
					</p>
				</Card>

				<Card title="서비스 상태" style={{ marginBottom: 24 }}>
					<Descriptions bordered column={1}>
						<Descriptions.Item label="GOMS 서비스">
							<antd.Tag color={(myInfo as any)?.gomsActive ? 'success' : 'default'}>
								{(myInfo as any)?.gomsActive ? '활성화' : '비활성화'}
							</antd.Tag>
						</Descriptions.Item>
						<Descriptions.Item label="WANT 서비스">
							<antd.Tag color={(myInfo as any)?.wantActive ? 'success' : 'default'}>
								{(myInfo as any)?.wantActive ? '활성화' : '비활성화'}
							</antd.Tag>
						</Descriptions.Item>
					</Descriptions>
					<p style={{ marginTop: 12, color: '#666', fontSize: 13 }}>
						서비스 활성화는 관리자에게 문의해 주세요.
					</p>
				</Card>
			</LectureView>
		</Wrapper>
	)
}

const Wrapper = styled(LectureWrapper)``
const EmptyState = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 200px;
	color: #999;
	font-size: 16px;
`
const FormRow = styled.div`
	margin-bottom: 16px;
`
const FormLabel = styled.label`
	display: block;
	margin-bottom: 6px;
	font-weight: 500;
	color: #333;
`
const ButtonRow = styled.div`
	margin-top: 16px;
	display: flex;
	gap: 8px;
`

export default MyAcademy
